import { render } from "./settingRow.vue?vue&type=template&id=099a6140&scoped=true"
import script from "./settingRow.vue?vue&type=script&lang=js"
export * from "./settingRow.vue?vue&type=script&lang=js"

import "../less/settingRow.less?vue&type=style&index=0&id=099a6140&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099a6140"]])

export default __exports__